module.exports = __webpack_public_path__ + "static/media/signup-avatar-bg.7aca37f3.jpg";